module.exports = __webpack_public_path__ + "static/doseQ3W-46e8803b59093614c625b87681c30574.png";